// Initiates Klaviyo on scroll
// --------------------------------------------------

import scriptLoader from "../utilities/scriptLoader";

document.addEventListener("scroll", () => {
    const loader = new scriptLoader('klaviyo');
    loader
        .load(["//www.klaviyo.com/media/js/public/klaviyo_subscribe.js"])
        .then(() => {
            console.log(`Klaviyo_subscribe loaded!`);
        });
}, { once: true });
